import React from "react";
import { Text, View } from "react-native";
import { Tabs, TabList, Tab } from "app/features/navigation/organisms/tabs";
import { PortalHost } from "ui/modules/ThrelsPortal/PortalHost";

interface TabItem {
  label: string;
  path: string;
}

interface PageLayoutProps {
  header?: React.ReactNode;
  children: React.ReactNode;
  tabs?: TabItem[];
  currentPath?: string;
  className?: string;
  headerClassName?: string;
  titleClassName?: string;
  screenName?: string;
  subtitle?: string;
}

export function PageLayout({
  header,
  children,
  tabs,
  currentPath,
  className,
  headerClassName,
  titleClassName,
  screenName,
  subtitle,
}: PageLayoutProps) {
  return (
    <View className={`bg-white h-full w-full ${className}`}>
      <View
        className={`flex flex-row items-end justify-between mb-7 border-b border-gray-200 min-h-[50px] ${tabs ? "" : "pb-3"} ${headerClassName}`}
      >
        <View className="flex-1">
          {tabs || header ? (
            <View className="flex flex-col items-start gap-5">
              {header ? header : null}
              {tabs ? (
                <Tabs>
                  <TabList>
                    {tabs?.map((tab) => (
                      <Tab
                        key={tab.path}
                        value={tab.path}
                        isActive={currentPath === tab.path}
                      >
                        <Text>{tab.label}</Text>
                      </Tab>
                    ))}
                  </TabList>
                </Tabs>
              ) : null}
            </View>
          ) : (
            <View className="gap-y-2">
              <Text className={`text-xl font-semibold ${titleClassName}`}>
                {screenName}
              </Text>
              <Text className="text-base">{subtitle}</Text>
            </View>
          )}
        </View>
        <PortalHost name="headerButton" />
      </View>
      <View className="flex-1">{children}</View>
    </View>
  );
}
